import styled from "styled-components";
import { ButtonPrimaryInternal } from "../Primary";
import { ButtonHoC } from "../button.js";
export const ButtonSecondaryInternal = styled(ButtonPrimaryInternal)`
  background-color: transparent;
  border: 2px solid ${props => props.theme.colors.action};
  color: ${props => props.theme.colors.action};
  padding: 7px 12px;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.buttonPrimaryBgHover};
    border-color: ${props => props.theme.colors.buttonPrimaryBgHover};
    color: ${props => props.theme.colors.buttonPrimaryText};
  }
`;
export const ButtonSecondary = ButtonHoC(ButtonSecondaryInternal);
export const ButtonSecondarySmallInternal = styled(ButtonSecondaryInternal)`
  min-width: 84px;
`;
export const ButtonSecondarySmall = ButtonHoC(ButtonSecondarySmallInternal);